// Ключи кэша тренировки (ключи `$api` — `[method, path, init]`): сводка — значок меню
// и блок на главной, серия — экран тренировки. Перечитываются после ответа и `drills.ready`.
export const DRILLS_OVERVIEW_QUERY_KEY = ["get", "/api/drills/overview"] as const;
export const DRILL_SERIES_QUERY_KEY = ["get", "/api/drills/series"] as const;
